import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import Authorize from '../../containers/Authorization';
import IframeComp from './IframeComp';
import intlC from '../../constants/intl';


class Iframe extends React.Component {
	render() {
		// TODO: refactor - use only one component for iframe.
		return (
			<div>
				<IframeComp intlObject={this.props.intlObject} />
			</div>
		)
	}
}


Iframe.propTypes = {
	intlObject: PropTypes.object.isRequired
};

function mapStateToProps(state) {
	return {
		intlObject: state.intl.get(intlC.INTL_OBJECT)
	};
}

export default connect(mapStateToProps)(Authorize(Iframe));



// WEBPACK FOOTER //
// ./components/Iframe/index.js